import { createAsyncThunk } from "@reduxjs/toolkit";
import { IGetActivityLogsRequest, IGetConflictResolutionPerformanceRequest, IGetContributionPerformanceRequest, IGetDashboardStatisticsRequest, IGetLastActivitiesRequest, IGetProcessedResourcesRequest, IGetSpecificationItemSourcesRequest, } from "@/shared/services/interface/requests/dashboard";
import { dashboardService } from "@/shared/services/api/dashboard-service";

export const getDashboardStatistics = createAsyncThunk(
  "dashboard/getDashboardStatistics",
  async (request: IGetDashboardStatisticsRequest, thunkAPI) => {
    try {
      const response = await dashboardService.getDashboardStatistics(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getActivityLogs = createAsyncThunk(
  "dashboard/getActivityLogs",
  async (request: IGetActivityLogsRequest, thunkAPI) => {
    try {
      const response = await dashboardService.getActivityLogs(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getSpecificationItemSources = createAsyncThunk(
  "dashboard/getSpecificationItemSources",
  async (request: IGetSpecificationItemSourcesRequest, thunkAPI) => {
    try {
      const response = await dashboardService.getSpecificationItemSources(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getLastActivities = createAsyncThunk(
  "dashboard/getLastActivities",
  async (request: IGetLastActivitiesRequest, thunkAPI) => {
    try {
      const response = await dashboardService.getLastActivities(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProcessedResources = createAsyncThunk(
  "dashboard/getProcessedResources",
  async (request: IGetProcessedResourcesRequest, thunkAPI) => {
    try {
      const response = await dashboardService.getProcessedResources(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getContributionPerformance = createAsyncThunk(
  "dashboard/getContributionPerformance",
  async (request: IGetContributionPerformanceRequest, thunkAPI) => {
    try {
      const response = await dashboardService.getContributionPerformance(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// /dashboard/{companyId}/conflict-resolution-performance
export const getConflictResolutionPerformance = createAsyncThunk(
  "dashboard/getConflictResolutionPerformance",
  async (request: IGetConflictResolutionPerformanceRequest, thunkAPI) => {
    try {
      const response = await dashboardService.getConflictResolutionPerformance(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);